// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {"__root":{"notificationPreferences_defaultPropertyNotificationAreas":{"f":""},"notificationPreferences_defaultNeedsNotificationAreas":{"f":""},"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

var Utils = {};

var node = ((function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "NotificationSettings_areas"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationSettings_chapter",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsForSaleProperties_chapter"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsRentalProperties_chapter"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsBuyerNeeds_chapter"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsRentalNeeds_chapter"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChapterNotificationPreferencesV5",
      "kind": "LinkedField",
      "name": "notificationPreferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Area",
          "kind": "LinkedField",
          "name": "defaultNeedsNotificationAreas",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Area",
          "kind": "LinkedField",
          "name": "defaultPropertyNotificationAreas",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ChapterV5",
  "abstractKey": null
};
})());

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
